import moment from 'moment'
import momentTimeZone from 'moment-timezone'
import config from 'services/config'

export function formatQueryDateToDate (dateString) {
    if (dateString === '' || dateString === null) {
        return null
    }
    if (Number.isInteger(dateString)) {
        dateString = dateString * 1000
    }

    let dateObject = new Date(dateString)
    let year = dateObject.getFullYear()
    let month = (`0${+dateObject.getMonth() + 1}`).slice(-2)
    let day = (`0${dateObject.getDate()}`).slice(-2)
    return `${year}-${month}-${day}`
}

export function formatDateToQueryString (dateString) {
    if (dateString === '' || dateString === null) {
        return null
    }
    return formatQueryDateToDate(dateString) + ' 12:00:00'
}

export function getYearlyArrayOfDatesInFormat (dateFormat, year) {
    let months = []
    if (year) {
        for (let i = 0; i < 12; i++) {
            let month = moment().year(year).month(i).format(dateFormat)
            months.push(month)
        }
        return months
    } else {
        for (let i = 0; i < 12; i++) {
            let month = moment().subtract(i, 'months').format(dateFormat)
            months.push(month)
        }
        return months.reverse()
    }
}

export function getDaysInMonth (month, year) {
    return moment(year + '-' + month, 'YYYY-MM').daysInMonth()
}

export function getUnixTimeStampByTimeZone () {
    switch (config.appLanguage) {
    case 'fi':
        return momentTimeZone().tz('Europe/Helsinki').unix()
    case 'se':
        return momentTimeZone().tz('Europe/Stockholm').unix()
    case 'no':
        return momentTimeZone().tz('Europe/Oslo').unix()
    case 'dk':
        return momentTimeZone().tz('Europe/Copenhagen').unix()
    }
}

export function getClockTimeByTimeZone () {
    let date = new Date(config.summitEnd * 1000)
    switch (config.appLanguage) {
    case 'fi':
        return momentTimeZone(date).tz('Europe/Helsinki').format('HH:mm')
    case 'se':
        return momentTimeZone(date).tz('Europe/Stockholm').format('HH:mm')
    case 'no':
        return momentTimeZone(date).tz('Europe/Oslo').format('HH:mm')
    case 'dk':
        return momentTimeZone().tz('Europe/Copenhagen').format('HH:mm')
    }
}

export function formattedDateForCountry (date) {
    switch (config.appLanguage) {
        case 'fi':
        case 'no':
            return moment(date).format('DD.MM.YYYY')
        case 'se':
            return moment(date).format('YYYY-MM-DD')
        default:
            return moment(date).format('DD.MM.YYYY')
    }
}

export default {
    methods: {
        formatQueryDateToDate: formatQueryDateToDate,
        formatDateToQueryString: formatDateToQueryString,
        getYearlyArrayOfDatesInFormat: getYearlyArrayOfDatesInFormat,
        getDaysInMonth: getDaysInMonth,
        getUnixTimeStampByTimeZone: getUnixTimeStampByTimeZone,
        getClockTimeByTimeZone: getClockTimeByTimeZone,
        formattedDateForCountry: formattedDateForCountry
    }
}
